module.exports = __webpack_public_path__ + "img/logo.28fa0206.svg";